import React, { useEffect, useState } from 'react';
import { Alert, Button, Spinner } from 'reactstrap';
import { getAuthenticatedDomains } from '../../../API/PhishingAPI';
import { unauthenticatedRecipients } from '../../../shared/authenticatedDomains';

export default function RecipientDomainGate({ recipients, revision = 0, hideWhenEmpty = false, onReady, onOpenSettings, t }) {
  const [state, setState] = useState({ loading: true, error: false, domains: [] });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true; setState(current => ({ ...current, loading: true, error: false }));
    getAuthenticatedDomains().then(result => {
      if (!Array.isArray(result?.domains)) throw new Error('Domain registry unavailable');
      if (active) setState({ loading: false, error: false, domains: result.domains });
    }).catch(() => { if (active) setState({ loading: false, error: true, domains: [] }); });
    return () => { active = false; };
  }, [revision, retry]);
  const emails = (recipients || []).map(target => target.email || '').join('\n');
  const blocked = unauthenticatedRecipients(recipients, state.domains);
  const ready = !state.loading && !state.error && !!recipients?.length && !blocked.length;
  useEffect(() => { onReady(ready); }, [ready, emails, onReady]);
  if (hideWhenEmpty && !(recipients || []).some(target => typeof target.email === 'string' && target.email.trim())) return null;
  if (state.loading) return <p role="status"><Spinner tag="span" size="sm" /> {t('authenticated_domains.validating')}</p>;
  if (ready) return <div className="alert alert-success" role="status">{t('authenticated_domains.recipients_ok')}</div>;
  const names = [...new Set(blocked.map(target => target.domain || t('authenticated_domains.invalid_email')))].join(', ');
  return <Alert color="danger" role="alert">{t(state.error ? 'authenticated_domains.policy_error' : 'authenticated_domains.blocked', { domains: names })}{' '}
    <Button color="link" onClick={() => setRetry(current => current + 1)}>{t('template_gallery.retry')}</Button>
    <Button color="link" onClick={onOpenSettings}>{t('delivery_settings.view_settings')}</Button>
  </Alert>;
}
